module.exports = __webpack_public_path__ + "img/resumen_clinico.3fa4178a.png";